// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"59fe1df5","131":"21883fbe","149":"0a3485d9","170":"4de6dc83","453":"a4596323","723":"ee4ee55c","743":"a51ba619"}[chunkId] + ".chunk.css";
};